import type { ReadonlyDeep } from 'type-fest';
import { z } from 'zod';

import { isOnnxCPU, isTensorFlowCPU, isTFLiteCPU } from '$lib/rdk';
import type { ModelTriplet } from '$lib/resource-type';

export const GenericMLModelServiceAttributesSchema = z
  .object({
    package_reference: z.string().optional(),
  })
  .passthrough()
  .catchall(z.any());

export const OnnxCPUAttributesSchema =
  GenericMLModelServiceAttributesSchema.extend({
    model_path: z.string().optional(),
    label_path: z.string().optional(),
  }).passthrough();

export const TFLiteCPUAttributesSchema =
  GenericMLModelServiceAttributesSchema.extend({
    model_path: z.string().optional(),
    label_path: z.string().optional(),
    num_threads: z.number().optional(),
  }).passthrough();

export const TensorFlowCPUAttributesSchema =
  GenericMLModelServiceAttributesSchema.extend({
    model_path: z.string().optional(),
    label_path: z.string().optional(),
  }).passthrough();

export type TFLiteCPUAttributes = ReadonlyDeep<
  z.infer<typeof TFLiteCPUAttributesSchema>
>;
export type OnnxCPUAttributes = ReadonlyDeep<
  z.infer<typeof OnnxCPUAttributesSchema>
>;
export type TensorFlowCPUAttributes = ReadonlyDeep<
  z.infer<typeof TensorFlowCPUAttributesSchema>
>;
export type GenericMLModelServiceAttributes = ReadonlyDeep<
  z.infer<typeof GenericMLModelServiceAttributesSchema>
>;

export type MLModelServiceAttributes =
  | TFLiteCPUAttributes
  | OnnxCPUAttributes
  | TensorFlowCPUAttributes
  | GenericMLModelServiceAttributes;

export const getMLModelFrameworkSchemaByService = (model: ModelTriplet) => {
  if (isTFLiteCPU(model)) {
    return TFLiteCPUAttributesSchema;
  }
  if (isOnnxCPU(model)) {
    return OnnxCPUAttributesSchema;
  }
  if (isTensorFlowCPU(model)) {
    return TensorFlowCPUAttributesSchema;
  }

  return GenericMLModelServiceAttributesSchema;
};
